// extracted by mini-css-extract-plugin
export default {"socialList":"JFrng","sizeLarge":"XvriM","iconSocial":"hDctQ","sizeSmall":"Siz1a"};